
const auth = {
  'auth.signIn': 'Anmelden',
  'auth.signUp': 'Registrieren',
  'auth.signOut': 'Abmelden',
  'auth.profile': 'Profil',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.resetPassword': 'Passwort zurücksetzen',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.haveAccount': 'Bereits ein Konto?',
  'auth.emailVerification': 'E-Mail-Verifizierung',
  'auth.emailVerificationSent': 'Eine Verifizierungs-E-Mail wurde an deine Adresse gesendet. Bitte überprüfe dein Postfach und folge den Anweisungen, um dein Konto zu bestätigen.',
  'auth.emailVerificationInfo': 'Bitte bestätige deine E-Mail-Adresse, bevor du dich anmeldest.',
  'auth.verificationSuccess': 'Deine E-Mail wurde erfolgreich bestätigt!',
  'auth.verificationError': 'Fehler bei der Bestätigung deiner E-Mail.',
  'auth.passwordRequirements': 'Das Passwort muss:',
  'auth.passwordLength': 'Mindestens 8 Zeichen lang sein',
  'auth.passwordUppercase': 'Mindestens einen Großbuchstaben enthalten',
  'auth.passwordLowercase': 'Mindestens einen Kleinbuchstaben enthalten',
  'auth.passwordNumber': 'Mindestens eine Zahl enthalten',
  'auth.passwordSpecial': 'Mindestens ein Sonderzeichen enthalten',
  'auth.passwordsDoNotMatch': 'Passwörter stimmen nicht überein',
  'auth.emailsDoNotMatch': 'E-Mails stimmen nicht überein',
  'auth.invalidEmail': 'Bitte gib eine gültige E-Mail-Adresse ein',
  'auth.mandatoryField': 'Dieses Feld ist erforderlich',
  'auth.usernameLength': 'Der Benutzername muss zwischen 3 und 20 Zeichen lang sein',
  'auth.usernameFormat': 'Der Benutzername darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten',
  'auth.nameFormat': 'Darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten',
  'auth.nameMaxLength': 'Darf 50 Zeichen nicht überschreiten',
  'auth.phoneFormat': 'Bitte gib eine gültige Telefonnummer ein',
  'auth.addressFormat': 'Die Adresse enthält ungültige Zeichen',
  'auth.addressMaxLength': 'Die Adresse darf 200 Zeichen nicht überschreiten',
  'auth.cityFormat': 'Die Stadt darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten',
  'auth.cityMaxLength': 'Die Stadt darf 100 Zeichen nicht überschreiten',
  'auth.postalCodeFormat': 'Die Postleitzahl darf nur Buchstaben, Zahlen, Leerzeichen und Bindestriche enthalten',
  'auth.postalCodeMaxLength': 'Die Postleitzahl darf 20 Zeichen nicht überschreiten',
  'auth.emailMaxLength': 'Die E-Mail-Adresse ist zu lang',
  'auth.passwordMaxLength': 'Das Passwort darf 128 Zeichen nicht überschreiten',
  'auth.phoneMinLength': 'Die Telefonnummer ist zu kurz',
  'auth.phoneMaxLength': 'Die Telefonnummer ist zu lang',
  'auth.suspiciousContent': 'Enthält potenziell schädliche Inhalte',
  'auth.reservedUsername': 'Der Benutzername ist reserviert',
  'auth.commonPassword': 'Das Passwort ist zu allgemein',
  'auth.minimumAge': 'Du musst mindestens 18 Jahre alt sein',
  'auth.loginError': 'Ungültige E-Mail oder Passwort',
  'auth.loginRequired': 'Bitte melde dich an, um dein Profil zu sehen',
  'auth.signUpError': 'Fehler beim Erstellen des Kontos',
  'auth.signOutError': 'Fehler beim Abmelden',
  'auth.usernameTaken': 'Der Benutzername ist bereits vergeben',
  'auth.emailTaken': 'Die E-Mail ist bereits vergeben',
  'auth.firstName': 'Vorname',
  'auth.lastName': 'Nachname',
  'auth.dateOfBirth': 'Geburtsdatum',
  'auth.gender': 'Geschlecht',
  'auth.selectGender': 'Geschlecht auswählen',
  'auth.male': 'Männlich',
  'auth.female': 'Weiblich',
  'auth.other': 'Andere',
  'auth.preferNotToSay': 'Keine Angabe',
  'auth.phone': 'Telefonnummer',
  'auth.phoneNumber': 'Telefonnummer',
  'auth.email': 'E-Mail',
  'auth.confirmEmail': 'E-Mail bestätigen',
  'auth.username': 'Benutzername',
  'auth.password': 'Passwort',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.agreeToTerms': 'Ich stimme den ',
  'auth.termsOfService': 'Nutzungsbedingungen',
  'auth.and': ' und ',
  'auth.privacyPolicy': 'Datenschutzrichtlinien',
  'auth.termsRequired': 'Du musst die Nutzungsbedingungen akzeptieren',
  'auth.country': 'Land',
  'auth.selectCountry': 'Land auswählen',
  'auth.countryCode': 'Ländervorwahl',
  'auth.selectCountryCode': 'Ländervorwahl auswählen',
  'auth.userInfo': 'Benutzerinformationen',
  'auth.contactInfo': 'Kontaktinformationen',
  'auth.accountInfo': 'Kontoinformationen',
  'auth.welcomeBack': 'Melde dich bei The Club an',
  'auth.welcomeMessage': 'Bitte gib deine Zugangsdaten ein, um dich anzumelden',
  'auth.createAccount': 'Erstelle dein The Club-Konto',
  'auth.createAccountMessage': 'Fülle die folgenden Informationen aus, um dein Konto zu erstellen',
  'auth.updateProfile': 'Profil aktualisieren',
  'auth.profileUpdated': 'Profil erfolgreich aktualisiert',
  'auth.profileUpdateError': 'Fehler beim Aktualisieren des Profils',
  'auth.selectDate': 'Datum auswählen',
  'auth.selectYear': 'Jahr auswählen',

  // Neue Übersetzungen für Passwort zurücksetzen
  'auth.resetPasswordInstructions': 'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.',
  'auth.sendResetEmail': 'E-Mail zum Zurücksetzen senden',
  'auth.resetEmailSent': 'Zurücksetzungs-E-Mail gesendet',
  'auth.resetEmailInstructions': 'Bitte überprüfe deine E-Mail für Anweisungen zum Zurücksetzen deines Passworts.',
  'auth.resetPasswordError': 'Fehler beim Zurücksetzen des Passworts',
  'auth.unexpectedError': 'Ein unerwarteter Fehler ist aufgetreten',
  'auth.createNewPassword': 'Erstelle ein neues Passwort für dein Konto',
  'auth.newPassword': 'Neues Passwort',
  'auth.backToSignIn': 'Zurück zur Anmeldung',
  'auth.passwordResetSuccess': 'Passwort erfolgreich zurückgesetzt',
  'auth.passwordResetSuccessMessage': 'Dein Passwort wurde erfolgreich zurückgesetzt. Du wirst zur Anmeldeseite weitergeleitet.',
  'auth.invalidResetLink': 'Ungültiger oder abgelaufener Zurücksetzungslink',
  'auth.tooManyAttempts': 'Zu viele Anmeldeversuche. Bitte versuche es später erneut.',

  // Neue Übersetzungen für mehrstufige Registrierung
  'auth.signUpWithGoogle': 'Mit Google registrieren',
  'auth.signUpWithFacebook': 'Mit Facebook registrieren',
  'auth.orContinueWithEmail': 'Oder fahre mit deiner E-Mail fort',
  'auth.next': 'Weiter',
  'auth.back': 'Zurück',
  'auth.stepTwoOfTwo': 'Schritt 2 von 2',
  
  // Neue Übersetzungen für fehlende UI-Elemente
  'auth.redirecting': 'Weiterleitung...',
  'auth.emailPlaceholder': 'du@beispiel.com',
  'auth.emailPlaceholderGeneric': 'email@beispiel.com',
  'auth.invalidRecoveryLink': 'Ungültiger Wiederherstellungslink. Bitte fordere einen neuen Passwort-Zurücksetzungslink an.',
  'auth.passwordResetTitle': 'Setze dein Passwort zurück',
  'auth.confirmNewPassword': 'Neues Passwort bestätigen',
  'auth.resetPasswordSubmit': 'Passwort zurücksetzen',

  // Zusätzliche Validierungsnachrichten
  'auth.emailValidationError': 'Bitte gib eine gültige E-Mail-Adresse ein',
  'auth.passwordValidationMinLength': 'Das Passwort muss mindestens 8 Zeichen lang sein',
  'auth.passwordValidationUppercase': 'Das Passwort muss mindestens einen Großbuchstaben enthalten',
  'auth.passwordValidationNumber': 'Das Passwort muss mindestens eine Zahl enthalten',
  'auth.passwordValidationSpecial': 'Das Passwort muss mindestens ein Sonderzeichen enthalten',
  'auth.passwordValidationMatch': 'Passwörter stimmen nicht überein',

  // Spezifische Nachrichten für Passwort zurücksetzen
  'auth.verifyingRecoveryLink': 'Wiederherstellungslink wird überprüft...',
  'auth.unableToVerifySession': 'Wiederherstellungssitzung kann nicht überprüft werden. Bitte fordere einen neuen Passwort-Zurücksetzungslink an.',
  'auth.unableToVerifyLink': 'Wiederherstellungslink kann nicht überprüft werden. Bitte fordere einen neuen Passwort-Zurücksetzungslink an.',
  'auth.invalidRecoverySession': 'Ungültige Wiederherstellungssitzung. Bitte fordere einen neuen Passwort-Zurücksetzungslink an.',
  'auth.requestNewResetLink': 'Neuen Zurücksetzungslink anfordern',

  // Allgemeine UI-Nachrichten
  'auth.emailVerifiedSignIn': 'Deine E-Mail wurde bestätigt. Bitte melde dich mit deinen Zugangsdaten an.',
  'auth.unexpectedErrorOccurred': 'Ein unerwarteter Fehler ist aufgetreten',

  //Supabase Error Messages
  // Authentication errors
  'auth.supabase.invalidCredentials': 'Ungültige E-Mail oder Passwort',
  'auth.supabase.emailNotConfirmed': 'Bitte bestätigen Sie Ihre E-Mail-Adresse vor der Anmeldung',
  'auth.supabase.userNotFound': 'Kein Konto mit dieser E-Mail-Adresse gefunden',
  'auth.supabase.passwordTooShort': 'Das Passwort muss mindestens 6 Zeichen lang sein',
  'auth.supabase.userAlreadyRegistered': 'Ein Konto mit dieser E-Mail existiert bereits',
  'auth.supabase.emailRateLimit': 'Zu viele E-Mails gesendet. Bitte warten Sie, bevor Sie eine weitere anfordern',
  'auth.supabase.invalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'auth.supabase.signupDisabled': 'Die Registrierung neuer Konten ist derzeit deaktiviert',
  'auth.supabase.invalidRecoveryToken': 'Ungültiger Passwort-Wiederherstellungslink',
  'auth.supabase.tokenExpired': 'Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen Passwort-Reset an',
  'auth.supabase.passwordTooWeak': 'Das Passwort ist zu schwach. Bitte wählen Sie ein stärkeres Passwort',
  
  // Database errors
  'auth.supabase.databaseError': 'Datenbankverbindungsfehler. Bitte versuchen Sie es später erneut',
  'auth.supabase.connectionTimeout': 'Verbindungszeitüberschreitung. Bitte überprüfen Sie Ihre Internetverbindung',
  'auth.supabase.internalError': 'Interner Serverfehler. Bitte versuchen Sie es später erneut',
  'auth.supabase.serviceUnavailable': 'Service vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut',
  'auth.supabase.requestTimeout': 'Anfragezeitüberschreitung. Bitte versuchen Sie es erneut',
  
  // Policy/Permission errors
  'auth.supabase.permissionDenied': 'Zugriff verweigert. Sie haben keine Berechtigung für diese Aktion',
  'auth.supabase.accessDenied': 'Zugriff verweigert',
  'auth.supabase.insufficientPermissions': 'Unzureichende Berechtigungen für diese Aktion',
  
  // Network errors
  'auth.supabase.networkError': 'Netzwerkverbindungsfehler. Bitte überprüfen Sie Ihre Internetverbindung',
  'auth.supabase.connectionError': 'Verbindungsfehler. Bitte versuchen Sie es erneut',
  
  // Generic patterns
  'auth.supabase.rateLimit': 'Zu viele Anfragen. Bitte warten Sie einen Moment, bevor Sie es erneut versuchen',
  'auth.supabase.invalidToken': 'Ungültiger Authentifizierungstoken. Bitte melden Sie sich erneut an',
  'auth.supabase.resourceNotFound': 'Angeforderte Ressource nicht gefunden',
  'auth.supabase.resourceAlreadyExists': 'Diese Ressource existiert bereits',
  
  // Generic fallback
  'auth.supabase.genericError': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut',

  // Invitation code field
  'auth.sponsor': 'Einladungscode',
  'auth.sponsorMandatory': '(erforderlich)',
  'auth.sponsorPlaceholder': 'Geben Sie Ihren Einladungscode ein',
  'auth.sponsorNotFound': 'Ungültiger Einladungscode. Bitte gültigen Code eingeben',
  'auth.sponsorRequired': 'Ein gültiger Einladungscode ist erforderlich',
  'auth.needSponsor': 'Brauchen Sie einen Einladungscode? Kontaktieren Sie einen The Club-Vertreter',

  // Email confirmation error
  'auth.confirmationFailed': 'E-Mail-Bestätigung fehlgeschlagen. Bitte überprüfe dein Postfach für den neuesten Bestätigungslink.',
  'auth.resendConfirmationEmail': 'Bestätigungs-E-Mail erneut senden',
  'auth.resendIn': 'Erneut senden in {{seconds}}',
  'auth.resendSuccess': 'Bestätigungs-E-Mail gesendet! Bitte überprüfe dein Postfach.',
  'auth.enterEmailToResend': 'Gib deine E-Mail ein, um den Bestätigungslink erneut zu senden',

  // Smart confirmation flow
  'auth.emailNeedsConfirmation': 'Diese E-Mail muss bestätigt werden. Ein Bestätigungslink wurde kürzlich gesendet — bitte überprüfe dein Postfach.',
  'auth.emailConfirmationResent': 'Diese E-Mail muss bestätigt werden. Eine neue Bestätigungs-E-Mail wurde gesendet — bitte überprüfe dein Postfach für den neuesten Link.',
  'auth.confirmationRecentlySent': 'Ein Bestätigungslink wurde kürzlich an diese E-Mail gesendet. Bitte überprüfe dein Postfach.',
  'auth.confirmationNewSent': 'Eine neue Bestätigungs-E-Mail wurde gesendet. Bitte überprüfe dein Postfach für den neuesten Bestätigungslink.',
  'auth.confirmationSentTo': 'Bestätigungs-E-Mail gesendet an:',
  'auth.verifyEmailResendInfo': 'E-Mail nicht erhalten?',

  // Already confirmed messages
  'auth.emailAlreadyConfirmed': 'Deine E-Mail-Adresse ist bereits verifiziert. Du kannst dich mit deinen Zugangsdaten anmelden.',
  'auth.emailAlreadyConfirmedSignIn': 'Deine E-Mail ist bereits verifiziert. Bitte melde dich unten an.',
};

export default auth;
